import Axios from "axios";
import {
  SET_TT_ALLOCATION_LIST,
  UNSET_TT_ALLOCATION_LIST,
} from "@/store/mutation-types";

import { ttAllocationResource } from "@/store/api";

const state = {
  getTtAllocationList: [],
};

const getters = {
  getTtAllocationList(state) {
    return state.getTtAllocationList;
  },
};

const mutations = {
  [SET_TT_ALLOCATION_LIST](state, data) {
    state.getTtAllocationList = data;
  },
  [UNSET_TT_ALLOCATION_LIST](state) {
    state.getTtAllocationList = [];
  },
};

const actions = {
    getTtAllocationList({ commit }, params = {}) {
        return new Promise((resolve, reject) => {
        Axios.get(ttAllocationResource, { params })
            .then((response) => {
            commit(SET_TT_ALLOCATION_LIST, response.data.data);
            resolve(response);
            })
            .catch((error) => {
            commit(UNSET_TT_ALLOCATION_LIST);
            reject(error);
            });
        });
    },

    saveTtAllocation({ commit }, data) {
        commit("SET_LOADING", { color: "primary" });

        return new Promise((resolve, reject) => {
        Axios.post(ttAllocationResource, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },

    updateTtAllocation({ commit }, { id, data }) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${ttAllocationResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.put(url, data)
            .then((response) => {
            resolve(response);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },
    getTtAllocation({ commit }, id) {
        commit("SET_LOADING", { color: "primary" });

        const url = `${ttAllocationResource}/${id}`;

        return new Promise((resolve, reject) => {
        Axios.get(url)
            .then((response) => {
            resolve(response.data.data);
            })
            .catch((error) => {
            reject(error);
            })
            .finally(() => {
            commit("UNSET_LOADING");
            });
        });
    },
};

export default {
  state,
  getters,
  actions,
  mutations,
};

